import {
  IN_REVIEW,
  PENDING_DETAILS,
  PROCESSING,
  REGISTERED,
  VALIDATING,
} from "constants/salesTaxRegistrationStatusType";

export const DUE_FILINGS = "DUE_FILINGS";
export const UNASSIGNED_SERVICE_TEAM = "UNASSIGNED_SERVICE_TEAM";
export const UNASSIGNED_PREPARER = "UNASSIGNED_PREPARER";
export const PENDING_REGISTRATIONS = "PENDING_REGISTRATIONS";
export const SERVICE_TEAM_IDS = "SERVICE_TEAM_IDS";
export const TASK_STATUS = "TASK_STATUS";
export const PAYMENT_SCHEDULE = "PAYMENT_SCHEDULE";
export const STATE = "STATE";

export const taskTypeOptions = [
  { label: "Monthly", value: "MONTHLY" },
  { label: "Quarterly", value: "QUARTERLY" },
  { label: "Semi Annually", value: "SEMI_ANNUALLY" },
  { label: "Annually", value: "ANNUALLY" },
];

export const taskStatusOptions = [
  { label: "Not started", value: "NOT_STARTED" },
  { label: "In cart", value: "IN_CART" },
  { label: "Processing", value: "PROCESSING" },
  { label: "Filed", value: "FILED" },
];

export type FilterOption = {
  STATE?: string;
  TASK_STATUS: string;
  PAYMENT_SCHEDULE?: string;
  SERVICE?: string;
  UNASSIGNED_SERVICE_TEAM?: boolean;
  UNASSIGNED_PREPARER?: boolean;
  DUE_FILINGS?: boolean;
  PENDING_REGISTRATIONS?: boolean;
  SERVICE_TEAM_IDS?: string;
};
export const registrationTaskStatusOptions = [
  { label: "Not started", value: PENDING_DETAILS },
  { label: "In review", value: IN_REVIEW },
  { label: "Processing", value: PROCESSING },
  { label: "In cart", value: VALIDATING },
  { label: "Registered", value: REGISTERED },
];

export type FilterKeyName =
  | "Task Type"
  | "State"
  | "Task Status"
  | "Service Team";

export type ColumnFilterKey =
  | "PAYMENT_SCHEDULE"
  | "STATE"
  | "TASK_STATUS"
  | "SERVICE_TEAM_IDS";

export const filterKeyMap = {
  "Task Type": PAYMENT_SCHEDULE,
  State: STATE,
  "Task Status": TASK_STATUS,
  "Service Team": SERVICE_TEAM_IDS,
};
